import { getMassActionsSuccessItemsLength } from '../../../../../../utils/massActions'

export function getIsListingProfileActionSucceeded(data) {
  return getMassActionsSuccessItemsLength(data) > 0
}
